<template>
  <div>
    <div style="overflow:hidden;">
      <div
        style="background-image:url(https://file.lgbfss.com/www/official/images/news1.jpg);height:713px"
      >
        <div class="content">
          <div class="container">
            <img
              src="https://file.lgbfss.com/www/official/images/news2.png"
              alt=""
              style="margin:280px -63px 0 -63px;"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 新闻动态 -->
    <div>
      <div class="content">
        <div class="container text-align-center">
          <div class="title font-color-2">新闻动态</div>
          <div class="sub-title">News Update</div>
          <div style="margin-bottom:50px;">
            <span class="slider slider-orange"></span>
          </div>
          <div>
            <div class="row">
              <div
                class="list-item"
                @click="goDetail(item.code)"
                v-for="item in currentList"
                :key="item.code"
              >
                <img
                  :src="item.cover"
                  alt=""
                  onerror="this.src= 'https://file.lgbfss.com/hr/adff90280bfb01107b2484d11b85a367/bjt.jpg'"
                />
                <!-- <img v-else src="" alt="" /> -->
                <div>
                  <p class="p-title text-hidden">{{ item.title }}</p>
                  <div><span class="split-line"></span></div>
                  <p class="p-content">{{ item.remark }}</p>
                  <p class="time">{{ item.create_time }}</p>
                </div>
              </div>
              <div class="list-item" style="opacity:0"></div>
              <div class="list-item" style="opacity:0"></div>
              <div class="list-item" style="opacity:0"></div>
            </div>
          </div>
          <div class="pagination">
            <span class="clickColor"> 共{{ total }}条</span>
            <span class="clickColor" style="margin:0 10px">
              每页{{ pageSize }}条</span
            >
            <el-pagination
              background
              :current-page.sync="pageNumber"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-size="pageSize"
              prev-text="上一页"
              next-text="下一页"
              layout="prev,pager, next,jumper"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <Nav></Nav>
    <Footer></Footer>
  </div>
</template>

<script>
import Nav from '../components/nav';
import Footer from '../components/footer';

export default {
  name: 'news',
  components: {
    Nav,
    Footer,
  },
  data: () => {
    return {
      dataList: [],
      currentList: [],
      total: 0,
      pageNumber: 1,
      pageSize: 6,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.$axios
        .post(this.$url + '/home.news.list.json', {
          pageSize: this.pageSize,
          pageNumber: this.pageNumber,
        })
        .then((res) => {
          console.log(res.data.data);

          if (res.data.data.list.length > 0) {
            this.currentList = res.data.data.list;
            this.total = res.data.data.total;
          }
        })
        .catch((err) => {
          this.msg = err;
        });
    },
    goDetail(id) {
      this.$router.push({
        path: '/news_detail',
        query: {
          id: id,
        },
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },
  },
};
</script>

<style lang="css" scoped>
.el-pagination button,
.el-pagination span:not([class*='suffix']) {
  padding: 0 10px;
  background: #5d7afa;
  color: #fff;
}
.el-pagination.is-background .btn-next.disabled,
.el-pagination.is-background .btn-next:disabled,
.el-pagination.is-background .btn-prev.disabled,
.el-pagination.is-background .btn-prev:disabled,
.el-pagination.is-background .el-pager li.disabled {
  background-color: #eee;
}
.pagination {
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #617dfa;
}
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  background: #ebeef4;
  border: 1px solid #bcbdc0;
}
.el-pagination__total,
.el-pagination__sizes,
.el-pagination__jump {
  color: #4977fc;
}
.text-align-center {
  text-align: center;
}

.title {
  font-size: 46px;
  font-weight: bold;
  padding: 58px 0 15px 0px;
}

.sub-title {
  font-size: 20px;
  color: #cbcbcb;
  font-family: Arial, Helvetica, sans-serif;
}
.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}
.content {
  color: #333333;
  padding: 5px 0;
}

.slider {
  display: inline-block;
  width: 80px;
  height: 3px;
}

.slider-orange {
  background-color: #f38303;
}

.slider-white {
  background-color: #ffffff;
}

.list-item {
  background-color: #ffffff;
  color: #333333;
  font-size: 20px;
  cursor: pointer;
  box-shadow: 0 0 10px 2px #dbdbdb;
  margin-bottom: 35px;
  text-align: left;
  padding-left: 12px 15px;
  width: 31%;
}

.list-item > div {
  padding: 12px 15px;
}

.list-item:hover {
  background-color: #64cdff;
  color: #ffffff;
}

.list-item > img {
  width: 100%;
  height: 150px;
}

.split-line {
  display: inline-block;
  width: 34px;
  height: 2px;
  background-color: #333333;
}

.list-item:hover .split-line {
  background-color: #ffffff;
}

.list-item p.p-title {
  font-size: 16px;
  margin-top: 12px;
}

.list-item p.p-content {
  line-height: 26px;
  font-size: 14px;
  color: #666666;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box; /* 设置n行，也包括1 */
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.list-item p.time {
  color: #999999;
  font-size: 12px;
}

.list-item:hover p.p-content,
.list-item:hover p.time {
  color: #ffffff;
}
</style>
